import { PayrollSystem } from '$constants'
import {
  XeroAuEmployee,
  transformXeroAuEmployeeAuOnGet,
} from './xeroAuEmployee'
import { XeroNzEmployee } from './xeroNzEmployee'

//PayrollEmployee is a union of available Payroll System Employees that are integrated with Loaded
export type PayrollEmployee = XeroAuEmployee | XeroNzEmployee

// Function to apply transformations to PayrollEmployee object on get
export const transformPayrollEmployeeOnGet = (
  payrollSystem: PayrollSystem | null,
  payrollEmployee: PayrollEmployee
): PayrollEmployee => {
  switch (payrollSystem) {
    case PayrollSystem.XeroAu:
      return transformXeroAuEmployeeAuOnGet(payrollEmployee)
    default:
      return payrollEmployee
  }
}
